// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3GOdc","tab":"ProcedureTabs_tab__2b9l1"};